import { useCallback } from 'react';
import { getLocalStorageItem, setLocalStorageItem } from '../../../../../utils';
import { IN_PROGRESS_LOT_IDS_KEY } from '../utils/batchHelpers';

/**
 * Custom hook to manage in-progress lot tracking in localStorage
 * @param {string} lotId - The lot ID to track
 * @returns {Object} - Object containing trackLot and untrackLot functions
 */
export const useInProgressLotTracking = (lotId) => {
  /**
   * Add lot ID to in-progress tracking
   */
  const trackLot = useCallback(() => {
    if (!lotId) return;
    const existing = getLocalStorageItem(IN_PROGRESS_LOT_IDS_KEY) || [];
    if (!existing.includes(lotId)) {
      setLocalStorageItem(IN_PROGRESS_LOT_IDS_KEY, [...existing, lotId]);
    }
  }, [lotId]);

  /**
   * Remove lot ID from in-progress tracking and dispatch update event
   */
  const untrackLot = useCallback(() => {
    if (!lotId) return;
    const current = getLocalStorageItem(IN_PROGRESS_LOT_IDS_KEY) || [];
    const updated = current.filter((id) => id !== lotId);
    setLocalStorageItem(IN_PROGRESS_LOT_IDS_KEY, updated);
    window.dispatchEvent(new Event('__inProgressLotUpdated'));
  }, [lotId]);

  return { trackLot, untrackLot };
};
